import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

import { fetchPosts } from '../actions/postActions';
import { fetchCarCats, fetchCarCat, fetchCars, fetchAllCars, fetchCar } from '../actions/carsActions';
import { fetchTehCats, fetchTehCat, fetchTehs, fetchAllTehs, fetchTeh } from '../actions/tehActions';
import { fetchReviews } from '../actions/reviewActions';
import { showModalForm, hideModalForm } from '../actions/coreActions';

import { Modal, Form, Container, Row, Col, ButtonGroup, Button, Image } from 'react-bootstrap';
import { CurrencyFormat } from 'react-currency-format';

// Swiper Slider
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/scrollbar/scrollbar.scss';


class Catalog extends Component {
    componentDidMount() {
        // this.props.fetchPosts()
        // this.props.fetchReviews()
        if (this.props.match.params.type === 'car') {
            this.props.fetchCarCats()
            if (this.props.match.params.id) {
                this.props.fetchCarCat(this.props.match.params.id)
                this.props.Cars(this.props.match.params.id)
            } else {
                this.props.fetchAllCars()
            }
        } else if (this.props.match.params.type === 'teh') {
            this.props.fetchTehCats()
            if (this.props.match.params.id) {
                this.props.fetchTehCat(this.props.match.params.id)
                this.props.fetchTehs(this.props.match.params.id)
            } else {
                this.props.fetchAllTehs()
            }
        }
        // this.props.fetchCar(this.props.match.params.id)
    }

    componentDidUpdate(type) {}

    constructor(props) {
        super(props);
        this.state = {
            productOfInterest: 'Не указано'
        };
    }


    render() {
        var CurrencyFormat = require('react-currency-format');
        var formProductName
        var formProductPhone

        const handleChangeInterest = (title) => {
            this.state.productOfInterest = title
        }

        const handleChangeName = (e) => {
            formProductName = e.target.value
        }
        const handleChangePhone = (e) => {
            formProductPhone = e.target.value
        }
        const handleOrderForm = () => {
            if (formProductPhone === '') {
                alert('Пожалуйста заполните поле Телефон')
            } else if (formProductName === '') {
                alert('Пожалуйста заполните поле Имя')
            } else {
                fetch('https://sinomost.kz', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        name: formProductName,
                        phone: formProductPhone,
                        backlink: 'https://sinomost.kz',
                        interest: this.state.productOfInterest,
                    })
                });

                this.props.hideModalForm('showOrderForm')

                alert('Благодарим Вас за проявленный интерес. Мы свяжемся с Вами в самое ближайшее время.')
            }
        }

        const order_form = (
            <Modal show={this.props.showOrderForm} onHide={() => this.props.hideModalForm('showOrderForm')}>
                <Modal.Header closeButton>
                    <Modal.Title>Оформить заказ</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Image
                        enableReinitialize={true}
                        destroyOnUnmount={true}
                        initialValues={this.props.request}
                        history={this.props.history}
                    />
                    <Form onSubmit={this.handleOrderForm}>
                        <Form.Group className="mb-3" controlId="formControlProductPhone">
                            <Form.Label>Ваш номер</Form.Label>
                            <Form.Control type="phone" name="phone" onChange={handleChangePhone} placeholder="+7(123)4567890" required />

                            <Form.Control.Feedback type="invalid">
                                Пожалуйста, укажите Ваш номер.
                            </Form.Control.Feedback>
                            {
                            //<Form.Text className="text-muted">
                                //We'll never share your email with anyone else.
                            //</Form.Text>
                            }
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formControlProductName">
                            <Form.Label>Ваше имя</Form.Label>
                            <Form.Control type="text" name="name" onChange={handleChangeName} placeholder="_______" required />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.props.hideModalForm('showOrderForm')}>
                        Закрыть
                    </Button>
                    <Button variant="primary" type="button" onClick={handleOrderForm}>
                        Оставить заявку
                    </Button>
                </Modal.Footer>
            </Modal>
        );




        const carcats = this.props.carcats.map(carcat => (
            <Button key={carcat.id} variant="primary" className="text-left" href={`/product/car/${carcat.id}`} onClick={() => this.props.fetchCars(carcat.id)}>{carcat.title}</Button>
        ));
        const carslist = this.props.cars.map(carcat => (
            <Button key={carcat.id} variant="primary" className="text-left" href={`/product/car/${carcat.id}`} onClick={() => this.props.fetchCars(carcat.id)}>{carcat.title}</Button>
        ));
        const cars = this.props.cars.map(car => (
            <Col xs={12} sm={6} md={4} xl={3} key={car.id} className="p-2 border-top">
                <Image src={`https://sinomost.kz${car.thumbnail}`} width="100%"></Image> 
                <p className="catalog-desc"><small>{car.title} | {car.category}</small></p>
                <p className="m-0 pb-1">Цена: {car.price_kzt}</p>
                <ButtonGroup className="justify-content-between catalog-buttons w-100">
                    <Button className="float-right" href={`/product/car/${car.id}`}>Подробнее</Button>
                    <Button className="float-right" onClick={() => {handleChangeInterest(car.title);this.props.showModalForm('showOrderForm');}}>Заказать</Button>
                </ButtonGroup>
            </Col>
        ));
        const tehcats = this.props.tehcats.map(tehcat => (
            <>{tehcat.items>0 &&
            <Button key={tehcat.id} variant="primary" className="text-left" href={`/catalog/teh/${tehcat.id}`} onClick={`/catalog/teh/${tehcat.id}`}>{tehcat.title}</Button>
            }</>
        ));
        const tehs = this.props.tehs.map(teh => (
            <Col xs={12} sm={6} md={4} xl={3} key={teh.id} className="p-2 border-top">
                <Image src={`https://sinomost.kz${teh.image}`} width="100%"></Image> 
                <p className="catalog-desc"><small>{teh.title} | {teh.category}</small></p>
                <p className="m-0 pb-1">Цена: {teh.price_kzt}</p>
                <ButtonGroup className="justify-content-between catalog-buttons w-100">
                    <Button className="float-right" href={`/product/teh/${teh.id}`}>Подробнее</Button>
                    <Button className="float-right" onClick={() => {handleChangeInterest(teh.title);this.props.showModalForm('showOrderForm');}}>Заказать</Button>
                </ButtonGroup>
            </Col>
        ));

        return (
            <>
            <Container className="catalog-navigation my-5">
                <Row className="mt-5">
                    <Col xs={12} sm={4} md={3} className="p-0">
                    {this.props.match.params.type === 'car' ?
                        <h1 className="h4">Каталог Автомобилей</h1>
                    : this.props.match.params.type === 'teh' ?
                        <h1 className="h4">Каталог Спецтехники</h1>
                    :
                        <h1 className="h4">Выберите каталог</h1>
                    }
                    {this.props.match.params.type === 'car' ?
                        <ButtonGroup className="w-100" vertical>
                            {carslist}
                            <Button className="text-left" variant="secondary" href={`/catalog/car/`} onClick={() => this.props.fetchAllCars()}>Смотреть все Автомобили</Button>
                            <Button className="text-left" variant="secondary" href={`/catalog/teh/`} onClick={() => this.props.fetchAllTehs()}>Смотреть всю Спецтехнику</Button>
                        </ButtonGroup>
                    : this.props.match.params.type === 'teh' ?
                        <ButtonGroup className="w-100" vertical>
                            {tehcats}
                            <Button className="text-left" variant="secondary" href={`/catalog/car/`} onClick={() => this.props.fetchAllCars()}>Смотреть все Автомобили</Button>
                            <Button className="text-left" variant="secondary" href={`/catalog/teh/`} onClick={() => this.props.fetchAllTehs()}>Смотреть всю Спецтехнику</Button>
                        </ButtonGroup>
                    :
                        <ButtonGroup className="w-100" vertical>
                            <Button className="text-left" variant="secondary" href={`/catalog/car`} onClick={() => this.props.fetchAllCars()}>Легковые автомобили</Button>
                            <Button className="text-left" variant="secondary" href={`/catalog/teh`} onClick={() => this.props.fetchAllTehs()}>Спецтехника</Button>
                        </ButtonGroup>
                    }
                    </Col>
                    <Col xs={12} sm={8} md={9} className="products">
                        <Row>
                            {this.props.match.params.type === 'car' ?
                                <>
                                <Helmet>
                                  <meta charset="UTF-8" />
                                  <title>Автомобили производства BAIC</title>
                                  <meta name="description" content="Автомобили производства компании BAIC. BJ40, BJ80, X55, X65, U7/D70, U5/D50. BAIC, Beijing, Senovo." />
                                  <meta name="keywords" content="BAIC, Beijing, Senovo, Liugong, Lonking, Фронтальные погразчики, самосвалы, краны, бульдозеры, экскаваторы, асфальтоукладчики, рейдеры. Кроссоверы, Седаны, Внедорожники" />
                                </Helmet>
                                {cars}
                                </>
                            : this.props.match.params.type === 'teh' ?
                                <>
                                <Helmet>
                                  <meta charset="UTF-8" />
                                  <title>Спецтехника всех видов.</title>
                                  <meta name="description" content="Фронтальные погразчики, самосвалы, краны, бульдозеры, экскаваторы, асфальтоукладчики, грейдеры." />
                                  <meta name="keywords" content="BAIC, Beijing, Senovo, Liugong, Lonking, Фронтальные погразчики, самосвалы, краны, бульдозеры, экскаваторы, асфальтоукладчики, грейдеры. Кроссоверы, Седаны, Внедорожники" />
                                </Helmet>
                                {tehs}
                                </>
                            :
                                <h1>Выберите вид техники для отображения</h1>
                            }
                        </Row>
                    </Col>
                    {order_form}
                </Row>
            </Container>
            </>
        );
    };
}

Catalog.propTypes = {
/*    fetchPosts: PropTypes.func.isRequired,
    posts: PropTypes.array.isRequired,
    fetchReviews: PropTypes.func.isRequired,
    reviews: PropTypes.array.isRequired,
    fetchCarCats: PropTypes.array.isRequired,
    carCats: PropTypes.array.isRequired,
    fetchCarCat: PropTypes.array.isRequired,
    carCat: PropTypes.array.isRequired,
    fetchCars: PropTypes.array.isRequired,
    cars: PropTypes.array.isRequired,
    fetchCar: PropTypes.array.isRequired,
    car: PropTypes.array.isRequired,*/
}

const mapStateToProps = state => ({
    posts: state.posts.items,
    reviews: state.reviews.items,
    carcats: state.cars.carcats,
    carcat: state.cars.carcat,
    cars: state.cars.cars,
    car: state.cars.car,
    tehcats: state.teh.tehcats,
    tehcat: state.teh.tehcat,
    tehs: state.teh.tehs,
    teh: state.teh.teh,
    showOrderForm: state.core.showOrderForm,
});

export default connect(mapStateToProps, { fetchPosts, fetchReviews, fetchCarCats, fetchCarCat, fetchCars, fetchAllCars, fetchCar, fetchTehCats, fetchTehCat, fetchTehs, fetchAllTehs, fetchTeh, showModalForm, hideModalForm })(Catalog);
